import { Typography, Box, Grid, Stack } from "@mui/material";
import ProductCard from "../components/ProductCard";
import { useState } from "react";
import { useInView } from "../components/hook";
import featuredCakes from "../components/featuredCakeList";
import CakeDetailsDialog from "../components/cakeDetailsDialog";
export default function Products() {
  const [ref, show] = useInView(0.1);
  const [selectedCake, setSelectedCake] = useState(null);
  return (
    <Box
      ref={ref}
      sx={{
        background: "#f7f4ec",
        width: "100%",
        alignItems: "center",
        justifyContent: "flex-start",
        display: "flex",
        flexDirection: "column",
        p: 4,
      }}
    >
      <Stack
        sx={{
          display: "flex",
          mt: 10,
          alignItems: "center",
          opacity: show ? 1 : 0,
          transform: show ? "translateY(0)" : "translateY(40px)",
          transition: "all 0.6s ease",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "37px",
            width: "155px",
            bgcolor: "#f7f4ec",
            borderRadius: "20px",
            boxShadow: "0 0 32px rgba(242,156,36,0.3)",
            animation: "glow 2.5s ease-in-out infinite",

            "@keyframes glow": {
              "0%": {
                boxShadow: "0 0 15px rgba(242, 156, 36, 0.73)",
              },
              "50%": {
                boxShadow: "0 0 22px rgba(242, 182, 99, 0.8)",
              },
              "100%": {
                boxShadow: "0 0 15px rgba(237, 184, 111, 0.77)",
              },
            },
          }}
        >
          <Typography
            sx={{ fontSize: "13px", fontWeight: 600, color: "#e99e26ff" }}
          >
            Our Specialties
          </Typography>
        </Box>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ md: 3 }}
          sx={{ mt: 2 }}
        >
          <Typography variant="h2">Featured</Typography>
          <Typography variant="h2" sx={{ color: "#e99e26ff" }}>
            Creations
          </Typography>
        </Stack>

        <Typography sx={{ maxWidth: "750px", wordWrap: "break-word", p: 3 }}>
          Each cake is a masterpiece, crafted with premium ingredients and
          artistic precision.
        </Typography>
      </Stack>

      <Grid
        ref={ref}
        container
        spacing={3}
        sx={{
          px: { xs: 2, md: 8 },
          mt: 4,
          display: "flex",
          justifyContent: "center",
        }}
      >
        {featuredCakes.map((cake, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={cake.id}>
            <ProductCard
              index={index}
              show={show}
              cake={cake}
              onOpen={setSelectedCake}
            />
          </Grid>
        ))}
      </Grid>
      <CakeDetailsDialog
        cake={selectedCake}
        open={Boolean(selectedCake)}
        onClose={() => setSelectedCake(null)}
      />
    </Box>
  );
}
